/* eslint-disable comma-dangle */
/* eslint-disable quotes */
/* eslint-disable semi */
import axios from "axios";
import ContactosContext from "context/ContactosContext";
import Parse from "helpers/Parse";
import { useContext } from "react";
const useContacts = () => {
  const { contactos, groups, getContactos } = useContext(ContactosContext);

  const handleDeleteContact = async (id) => {
    const response = await fetch(
      `https://api.sendhub.com/v1/contacts/${id}/?username=${process.env.REACT_APP_SENDHUB_USERNAME}&api_key=${process.env.REACT_APP_SENDHUB_APIKEY}`,
      {
        method: "DELETE",
      }
    );
    if (response.status === 204) {
      // getContactos()
    }
  };

  const handleAddContact = async (contact) => {
    const { name, number } = contact;
    const myNewObject = new Parse.Object("Contactos");
    myNewObject.set("name", name);
    myNewObject.set("phone", number);
    try {
      const result = await myNewObject.save();
      // Access the Parse Object attributes using the .GET method
      console.log("Contactos created", result);
    } catch (error) {
      console.error("Error while creating Contactos: ", error);
    }
  };

  const SendSMSToGroup = async (groupid, body) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/bulksms`,
        { grupo: groupid, body }
      );
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const getFamiliars = async (phone) => {
    const Remesas = Parse.Object.extend("Remesas");
    const query = new Parse.Query(Remesas);
    // You can also query by using a parameter of an object
    query.equalTo("confirmationPhone", phone);
    try {
      const results = await query.find();

      const contactos = results.map((result) => {
        return {
          name: result.get("nombre"),
          number: result.get("telefono"),
          envio: result.get("envio"),
          id: result.objectId,
        };
      });
      return contactos;
    } catch (error) {
      console.error("Error while fetching Remesas", error);
    }
  };

  const getContactId = (phone) =>
    contactos.filter((contact) => contact.number === `+1${phone}`)[0]?.id;

  return {
    contactos,
    groups,
    getContactos,
    handleDeleteContact,
    handleAddContact,
    getContactId,
    SendSMSToGroup,
    getFamiliars,
  };
};

export default useContacts;
